import angular from 'angular';
import { chain } from 'lodash';

const PARKING = {
  'garage_attached': { order: 1, text: 'Attached Garage' },
  'garage_detached': { order: 2, text: 'Detached Garage' },
  'carport': { order: 3, text: 'Carport' },
  'off_street': { order: 4, text: 'Off Street' },
  'rv': { order: 5, text: 'RV' },
  'tandem': { order: 6, text: 'Tandem' },
  'on_street': { order: 7, text: 'Street Parking' }
};

function parkingOrder(parkingType) {
  return PARKING[parkingType].order;
}

function parkingText(parkingType) {
  return PARKING[parkingType].text;
}

// Turns the parking types array into a string
module.exports = angular.module('common.filters.stringify-parking-types', [
])
.filter('stringifyParkingTypes', function() {
  return function(parkingTypes){
    return chain(parkingTypes).sortBy(parkingOrder).map(parkingText).join(', ').value();
  };
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/filters/stringify-parking-types.js
 **/